module.exports = __webpack_public_path__ + "img/user-cover-img.b0258d20.jpg";